import "./index.css";
import { JsPsych, JsPsychPlugin, ParameterType, TrialType } from "jspsych";
import { startColorsortTrial, StartColorsortTrialParams } from "./ColorSortPluginWrapper";

const info = <const>{
  name: "plugin-colorsort",
  version: "0.0.1",
  parameters: {
    /**
     * The initial tube configurations.
     * An array of objects, each with a `segments` array describing bottom→top slots.
     */
    initial_tubes: {
      type: ParameterType.COMPLEX,
      array: true,
      default: undefined,
    },
    /** Whether the user is allowed to undo moves. */
    undo_enabled: {
      type: ParameterType.BOOL,
      default: true,
    },
    /** Whether the user is allowed to reset the level. */
    reset_enabled: {
      type: ParameterType.BOOL,
      default: true,
    },
  },
  data: {
    /**
     * The full action log (pours, undos, resets) with timestamps and descriptions.
     */
    events: {
      type: ParameterType.COMPLEX,
    },
  },
  citations: "__CITATIONS__",
};

type Info = typeof info;

/**
 * **plugin-colorsort**
 *
 * A jsPsych wrapper around the React-based ColorSortApp.
 *
 * @author Justin Yang
 * @see {@link /plugin-colorsort/README.md}
 */
class ColorsortPlugin implements JsPsychPlugin<Info> {
  static info = info;

  constructor(private jsPsych: JsPsych) {}

  /**
   * Launches the trial by invoking startColorsortTrial
   * with the display element, parameters, and jsPsych instance.
   */
  trial(display_element: HTMLElement, trial: TrialType<Info>) {
    const params: StartColorsortTrialParams = {
      initialTubes: trial.initial_tubes,
      undoEnabled:  trial.undo_enabled,
      resetEnabled: trial.reset_enabled,
    };
    startColorsortTrial(display_element, params, this.jsPsych);
  }
}

export default ColorsortPlugin;
